var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3889 16C25.729 16.0004 25.0806 16.1736 24.5084 16.5024C23.9363 16.8312 23.4602 17.3041 23.1276 17.8741L16.5165 29.2075C16.1788 29.7851 16.0006 30.442 16 31.1111V76.4444C16 80.5738 19.4262 84 23.5556 84H76.4444C80.5738 84 84 80.5738 84 76.4444V31.1111C83.9994 30.442 83.8212 29.7851 83.4835 29.2075L76.8724 17.8741C76.5398 17.3041 76.0637 16.8312 75.4916 16.5024C74.9194 16.1736 74.271 16.0004 73.6111 16H26.3889ZM28.5582 23.5556H71.4418L75.8468 31.1111H24.1532L28.5582 23.5556ZM23.5556 38.6667H76.4444V76.4444H23.5556V38.6667ZM38.6667 46.2222V53.7778H61.3333V46.2222H38.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetManagement);
export default __webpack_public_path__ + "static/media/asset_management.fddfbc14dc21b2d80ac753dd27cf48e1.svg";
export { ForwardRef as ReactComponent };